import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
import i18n from "@/helpers/i18n";

export interface News {
  code: string,
  title: string,
  imageKey: string | null,
  content: string,
  createdAt: number,
}

export interface State {
  news:News[],
  loading:boolean
}


const defaultState: State = {
  news:[],
  loading:false
};

const getters = {
  loading: (state: State) => state.loading,
  news: (state: State) => state.news,
}

const mutations: MutationTree<State> = {
  setNews(state: State, payload: News[]) {
    state.news = payload
  },
  setOneNews(state: State, payload: News) {
    state.news.push(payload)
  },
  setLoadStatus(state: State, payload:boolean) {
    state.loading = payload
  },
  editOneNews(state: State, payload:News) {
    console.log(payload)
    const arr = state.news.map((el)=>
    {
      if(el.code === payload.code){
        return payload
      } else {
        return el
      }
    })
   state.news = JSON.parse(JSON.stringify(arr))
  },
}

const actions: ActionTree<State, RootState> = {
  async loadNewsFromServer({commit, state},payload:string) {
    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/'+payload+'/news')
      if(data.error){
        throw (data.error)
      }
      commit('setNews', data.data)
      commit('setLoadStatus', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('news.notifications.news_loaded')]
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }


  },
  async saveNewsFromServer({commit, state},payload:any){
    const show = payload.path
    let params = payload
    delete params.path

    try {
      const {data} = await axios.post('/v4/show/'+ show+'/news', params)
      commit('setOneNews', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('news.notifications.news_added')]
      })
    }catch (e) {


    }
  },
  async editNewsFromServer({commit, state},payload:any){
    const code = payload.code
    let params = payload
    delete params.code
    try {
      const {data} = await axios.patch('/v4/show/news/'+code, params)
      commit('editOneNews', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('news.notifications.news_update')]
      })
    }catch (e) {


    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
